import { render, staticRenderFns } from "./importMsgDialog.vue?vue&type=template&id=769e57a0&scoped=true"
import script from "./importMsgDialog.vue?vue&type=script&lang=js"
export * from "./importMsgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e57a0",
  null
  
)

export default component.exports